import * as NoteTranscript from '../models/note/transcript';

import { Common } from '../common';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async findLatestOneByNoteId(
    noteId: string,
  ): Promise<NoteTranscript.NoteTranscriptWithSegmentEntities> {
    const url = this.common.constructPath(`/note-transcripts`, {
      noteId,
      isCurrent: true,
      kind: NoteTranscript.Kind.Dictation,
    });
    const [latest]: [NoteTranscript.NoteTranscriptWithSegmentEntities] =
      await this.common.getJSON(url);
    return latest;
  }
}
